import { useContext } from 'react';

import HomeHeader from '../../common/HomeHeader';
import Clock from '../../common/Clock';
import BackgroundSlideshow from '../../common/BackgroundSlideshow';
import RadioContext from '../../RadioContext';

import bgPlayerDefault from '../../../images/bg-player-default.jpg';

const SCRIM =
  'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.2) 30%, rgba(0,0,0,0) 80%, rgba(0,0,0,0.6) 100%)';

function Home() {
  const { settings } = useContext(RadioContext);
  const slideshow = settings.bgPlayerSlideshow;

  return (
    <div className="relative w-full h-full">
      {slideshow ? (
        <BackgroundSlideshow
          images={slideshow.images}
          fadeTime={slideshow.fadeTime}
        />
      ) : (
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `${SCRIM}, url(${bgPlayerDefault})` }}
        />
      )}
      <HomeHeader />
      <div className="absolute bottom-0 left-0 z-10 w-full px-6 py-5 md:px-10 md:py-6">
        <Clock />
      </div>
    </div>
  );
}

export default Home;
